import { UploadFile } from "antd";
import { BuscaUrlPreAssinada } from "../../models/arquivoAnexo/chamadas/buscaUrlPreAssinada";
import api from "../api";
import { toastError } from "../toast";

export const sendImageToAmazonS3 = async (file: UploadFile) => {
  if (file.url?.includes("http")) return file.url;
  let buscaUrl: BuscaUrlPreAssinada = {
    fileName: file.name,
    contentType: file.type!,
  };

  const retorno = await api.get("/ArquivoAnexo/presigned-url", {
    params: { fileName: buscaUrl.fileName, contentType: buscaUrl.contentType },
  });

  const uploadRes = await fetch(retorno.data.data.url, {
    method: "PUT",
    headers: {
      "Content-Type": file.type!,
      "x-amz-acl": "public-read",
    },
    body: file.originFileObj,
  });

  if (!uploadRes.ok) {
    toastError("Ocorreu um erro ao fazer o upload do arquivo");
    throw new Error("Erro ao fazer upload para o S3");
  }

  let fileUrl: string = retorno.data.data.url.split("?")[0];
  return fileUrl;
};
